import { Input, Select, Table, message } from "antd";
import { useEffect, useState } from "react";
import {
  getAppointmentStatusColor,
  hasPermission,
  setState,
  sortAppointmentsByDateTimeDesc,
} from "../../../helpers/utilities";
import { format, isYesterday } from "date-fns";
import { isToday } from "date-fns/esm";
import { Badge, Chip, Menu, Modal } from "@mantine/core";
import { action, resouces } from "../../../helpers/auth";
import _ from "lodash";
import EditAppointmentComponent from "../../schedule/components/edit-appointment";
import { AddToCalendarComponent } from "../../../components";
import smalltalk from "smalltalk";
import { deleteAppointment } from "../../../helpers/api";
import {
  IconCalendar,
  IconDotsCircleHorizontal,
  IconEye,
  IconFirstAidKit,
  IconTrash,
} from "@tabler/icons";
import ConsultationDetail from "../../schedule/components/consultation-detail";

const AppointmentsComponent = ({ data, isLoading, refresh }) => {
  const [filteredData, setFilteredData] = useState([]);

  const { Search } = Input;
  const { Option } = Select;

  const [modal, setModal] = useState({
    title: "",
    open: false,
    content: "",
    size: "lg",
    zIndex: 1000,
  });

  useEffect(() => {
    setFilteredData(sortAppointmentsByDateTimeDesc(data));
  }, [data]);

  // sales table
  const columns = [
    {
      title: "Date",
      sorter: (a, b) => new Date(b.startTime) - new Date(a.startTime),
      sortDirections: ["descend", "ascend"],
      defaultSortOrder: "ascend",
      render: (text, record, index) =>
        isToday(new Date(record?.startDate))
          ? "Today "
          : isYesterday(new Date(record?.startDate))
            ? "Yesterday "
            : format(new Date(record?.startDate), "MMM dd, YYY"),
      width: 120,
    },
    {
      title: "Time",
      sorter: (a, b) => new Date(b.startTime) - new Date(a.startTime),
      sortDirections: ["descend", "ascend"],
      width: 100,
      render: (text, record, index) =>
        format(new Date(record?.startTime), "h:mm a"),
    },
    {
      title: "Name",
      sorter: (a, b) => a?.fullName > b?.fullName,
      sortDirections: ["descend", "ascend"],
      // width: 200,
      render: (text, record, index) =>
        record?.patient
          ? `${record?.patient?.firstName} ${record?.patient?.lastName}`
          : record?.fullName,
    },
    {
      title: "Contact",
      sorter: (a, b) => a?.contact > b?.contact,
      dataIndex: "contact",
      sortDirections: ["descend", "ascend"],
      width: 120,
      render: (text, record, index) =>
        record?.patient?.contact || record?.contact,
    },
    {
      title: "Type",
      sorter: (a, b) => a?.appointmentType > b?.appointmentType,
      dataIndex: "appointmentType",
      width: 100,
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) => _.capitalize(record?.appointmentType),
    },
    {
      title: "Source",
      sorter: (a, b) => a?.source > b?.source,
      dataIndex: "source",
      width: 100,
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) =>
        record?.source === "internal" ? "CareOS" : "External",
    },
    {
      title: "Status",
      sorter: (a, b) => a?.status > b?.status,
      dataIndex: "status",
      width: 150,
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) => (
        <Badge color={getAppointmentStatusColor(record.status)}>
          {_.capitalize(record.status)}
        </Badge>
      ),
    },
    {
      title: "-",
      width: 50,
      render: (text, record, index) => (
        <Menu shadow="md" width={180}>
          <Menu.Target>
            <button className="button app-btn is-ghost">
              <IconDotsCircleHorizontal />
              {/* <span className="bi bi-list me-2"></span> */}
            </button>
          </Menu.Target>

          <Menu.Dropdown>
            {
              // hasPermission( resouces.patients, action.canRead ) &&
              <>
                <Menu.Item
                  color="blue"
                  // icon={ <span className="bi bi-arrow-up-right-square" /> }
                  onClick={() => {
                    setModal({
                      title: "Appointment",
                      open: true,
                      size: "lg",
                      zIndex: 100,
                      content: (
                        <EditAppointmentComponent
                          onRefresh={refresh}
                          appointmentId={record.id}
                        />
                      ),
                    });
                  }}>
                  <IconEye size={20} className="me-2" />
                  Open
                </Menu.Item>
                {/* <Menu.Item
                  icon={ <span className="bi bi-pencil" /> }>
                  Edit
                </Menu.Item> */}
                <Menu.Item
                  onClick={() =>
                    setModal({
                      title: "Add to Calendar",
                      open: true,
                      size: "xs",
                      content: (
                        <AddToCalendarComponent
                          event={{
                            title: `${_.capitalize(
                              record.appointmentType
                            )} Consultation with ${record?.patient
                              ? `${record?.patient?.firstName} ${record?.patient?.lastName}`
                              : record?.fullName
                              }`,
                            description:
                              "This is an auto-generated patient appointment schedule from CareOS",
                            start: new Date(record.startTime),
                            duration: [30, "minute"],
                          }}
                        />
                      ),
                    })
                  }>
                  <IconCalendar size={20} color="grey" className="me-2" />
                  Add to Calendar
                </Menu.Item>

                {/* view consultation */}
                <Menu.Item
                  disabled={!record?.consultationId}
                  onClick={() =>
                    setModal({
                      title: "Appointment Consultation",
                      open: true,
                      size: "xl",
                      content: (
                        <ConsultationDetail
                          consultationId={record?.consultationId}
                          refresh={() => null}
                        />
                      ),
                    })
                  }>
                  <IconFirstAidKit size={20} color="grey" className="me-2" />
                  Consultation
                </Menu.Item>
              </>
            }
            {
              // hasPermission( resouces.patients, action.canDelete ) &&
              <Menu.Item
                // icon={ <span className="bi bi-trash" /> }
                color="red"
                onClick={() => {
                  smalltalk
                    .confirm(
                      "Delete Appointment",
                      "This action cannot be undone. Continue?",
                      {
                        buttons: {
                          ok: "YES",
                          cancel: "NO",
                        },
                      }
                    )
                    .then((go) => {
                      deleteAppointment(record.id)
                        .then((res) => {
                          message.success("done!");
                          refresh();
                        })
                        .catch(() =>
                          message.error("error processing request!")
                        );
                    })
                    .catch((ex) => {
                      return false;
                    });
                }}>
                <IconTrash size={20} className="me-2" />
                Delete
              </Menu.Item>
            }
          </Menu.Dropdown>
        </Menu>
      ),
    },
  ];

  return (
    <section>
      <Modal
        title={modal.title}
        opened={modal.open}
        size={modal.size}
        zIndex={modal.zIndex}
        onClose={() => setModal({ ...modal, open: false })}>
        {modal.content}
      </Modal>
      <>
        <p>
          Showing <strong>{filteredData?.length}</strong>{" "}
          {filteredData?.length > 1 ? " appointments" : "appointment"}
        </p>

        <div className="my-1 d-flex justify-content-between">
          <Search
            onChange={(e) => {
              const query = e.target.value.toLowerCase();
              setFilteredData(
                sortAppointmentsByDateTimeDesc(
                  data.filter(
                    (p) =>
                      p?.patient?.firstName
                        ?.toLowerCase()
                        ?.includes(query) ||
                      p?.patient?.lastName
                        ?.toLowerCase()
                        ?.includes(query) ||
                      p?.patient?.contact
                        ?.toLowerCase()
                        ?.includes(query) ||
                      p?.source?.toLowerCase()?.includes(query) ||
                      p?.appointmentType
                        ?.toLowerCase()
                        ?.includes(query) ||
                      p?.fullName?.toLowerCase()?.includes(query) ||
                      p?.contact?.toLowerCase()?.includes(query)
                  )
                )
              );
            }}
            title="search by contact, name or appointment type."
            placeholder="search by contact, name or appointment type"
          />
          <Select
            style={{ minWidth: "150px" }}
            name="type"
            className="mx-2"
            onChange={(v) =>
              setFilteredData(
                sortAppointmentsByDateTimeDesc(
                  data.filter((d) => d.appointmentType === v)
                )
              )
            }
            defaultValue="appointment type">
            {[...new Set(data.map((d) => d.appointmentType))].map((v) => (
              <Option value={v} key={v}>
                {v}
              </Option>
            ))}
          </Select>
          <button
            onClick={() =>
              setFilteredData(sortAppointmentsByDateTimeDesc(data))
            }
            className="app-btn btn-text d-flex align-items-center">
            <span className="bi bi-arrow-clockwise me-2"></span>
            Reset
          </button>
        </div>
        <div className="row mt-2">
          <div className="col-12">
            <Table
              className="border"
              rowKey={(record) => record.id}
              dataSource={filteredData}
              columns={columns}
              loading={isLoading}
              bordered
            />
          </div>
        </div>
      </>
    </section>
  );
};

export default AppointmentsComponent;
